import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { ThresholdListing } from './thresholds';
import { ThresholdsForm } from './thresholds-form';

export const ThresholdsRouter: React.FC = () => (
    <Switch>
        <Route exact path='/cris/thresholds' component={ThresholdListing} />
        <Route exact path='/cris/thresholds/new/create' component={ThresholdsForm} />
        <Route exact path='/cris/thresholds/:id/edit' component={ThresholdsForm} />
    </Switch>
);
